import React, { useState } from 'react';
import VideoStream from './VideoStream';
import { FiPlay, FiSquare, FiAlertCircle, FiCopy } from 'react-icons/fi';
import { toast } from 'react-hot-toast';

const StreamPreview = ({ stream, onStartStream, onEndStream }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const isLive = stream?.status === 'live';

  const handleStartStream = async () => {
    try {
      setIsLoading(true);
      setError(null);
      await onStartStream();
      toast.success('Stream started successfully');
    } catch (err) {
      console.error('Error starting stream:', err);
      setError('Failed to start stream');
      toast.error('Failed to start stream');
    } finally {
      setIsLoading(false);
    }
  };

  const handleEndStream = async () => {
    try {
      setIsLoading(true);
      setError(null);
      await onEndStream();
      toast.success('Stream ended successfully');
    } catch (err) {
      console.error('Error ending stream:', err);
      setError('Failed to end stream');
      toast.error('Failed to end stream');
    } finally {
      setIsLoading(false);
    }
  };

  const handleCopyStreamKey = () => {
    if (stream?.streamKey) {
      navigator.clipboard.writeText(stream.streamKey);
      toast.success('Stream key copied to clipboard');
    }
  };

  return (
    <div className="space-y-4">
      <div className="bg-black rounded-lg overflow-hidden aspect-video relative">
        {isLive ? (
          <VideoStream streamKey={stream.id} isLive={isLive} />
        ) : (
          <div className="absolute inset-0 flex flex-col items-center justify-center bg-gray-900">
            <span className="text-gray-400 text-lg mb-4">Stream Preview</span>
            {stream?.streamKey && (
              <div className="flex items-center space-x-2 bg-gray-800 rounded-lg p-2">
                <span className="text-gray-400 text-sm">Stream Key:</span>
                <span className="text-white font-mono">{stream.streamKey}</span>
                <button
                  onClick={handleCopyStreamKey}
                  className="text-gray-400 hover:text-white"
                >
                  <FiCopy className="w-4 h-4" />
                </button>
              </div>
            )}
          </div>
        )}
      </div>
      
      <div className="bg-gray-800 rounded-lg p-4">
        {error && (
          <div className="bg-red-500/10 text-red-500 p-3 rounded-lg mb-4 flex items-center">
            <FiAlertCircle className="w-5 h-5 mr-2" />
            <span>{error}</span>
          </div>
        )}
        
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center">
            <div className={`w-3 h-3 rounded-full mr-2 ${isLive ? 'bg-red-500' : 'bg-gray-500'}`}></div>
            <span className="text-white">{isLive ? 'LIVE' : 'OFFLINE'}</span>
          </div>
          <div className="text-gray-300">
            <span className="font-medium">{stream?.viewerCount || 0}</span> viewers
          </div>
        </div>
        
        <div className="flex justify-center">
          {isLive ? (
            <button
              onClick={handleEndStream}
              disabled={isLoading}
              className="flex items-center space-x-2 bg-red-600 text-white px-6 py-2 rounded-lg hover:bg-red-700 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              <FiSquare className="w-5 h-5" />
              <span>{isLoading ? 'Ending Stream...' : 'End Stream'}</span>
            </button>
          ) : (
            <button
              onClick={handleStartStream}
              disabled={isLoading}
              className="flex items-center space-x-2 bg-green-600 text-white px-6 py-2 rounded-lg hover:bg-green-700 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              <FiPlay className="w-5 h-5" />
              <span>{isLoading ? 'Starting Stream...' : 'Start Stream'}</span>
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default StreamPreview; 